/**
 * Created by ddodson on 1/7/16.
 */

export const ActionTypes = {
  // Batch actions
  BATCH_ACTIONS: "BATCH_ACTIONS",

  // Global setting actions
  SET_CONTROL_TYPE: "SET_CONTROL_TYPE",
  SET_CONTROLS_ENABLED: "SET_CONTROLS_ENABLED",
  SET_WATER_LEVEL: "SET_WATER_LEVEL",
  SET_FORECAST_CTRL: "SET_FORECAST_CTRL",
  SET_FORECAST_METADATA: "SET_FORECAST_METADATA",
  SET_TIMELINE_FORECAST: "SET_TIMELINE_FORECAST",
  SET_PRESET: "SET_PRESET",
  SET_PRESET_LEVELS: "SET_PRESET_LEVELS",
  SET_SUMMARY: "SET_SUMMARY",

  // Navigation actions
  SET_PLACE: "SET_PLACE",
  SET_PLACE_NAME: "SET_PLACE_NAME",
  SET_POPULATION: "SET_POPULATION",
  SET_SSID: "SET_SSID",
  SET_STATIONS: "SET_STATIONS",
  SET_ASLR_STATION: "SET_ASLR_STATION",
  SET_STATION_NUM: "SET_STATION_NUM",
  SET_MAP_POSITION: "SET_MAP_POSITION",
  SET_MAP_CAPTION: "SET_MAP_CAPTION",

  SET_MAP_LAYER: "SET_MAP_LAYER",
  SET_PLACE_CONTAINER: "SET_PLACE_CONTAINER",
  SET_QUERY: "SET_QUERY",
  SET_EMBED: "SET_EMBED",
  SET_DOWNLOAD_FORM_ID: "SET_DOWNLOAD_FORM_ID",

  // Component-specific actions
  SET_PROTECTION: "SET_PROTECTION",
  SET_IMPACT_GROUP: "SET_IMPACT_GROUP",
  SET_IMPACT_SUBGROUP: "SET_IMPACT_SUBGROUP",
  SET_IMPACT_SUBGROUP_EXCLUSIONS: "SET_IMPACT_SUBGROUPS",
  SET_IMPACT: "SET_IMPACT",
  SET_IMPACT_NAME: "SET_IMPACT_NAME",
  SET_IMPACT_PCT: "SET_IMPACT_PCT",
  SET_FORECAST_TYPE: "SET_FORECAST_TYPE",
  SET_FORECAST_NAME: "SET_FORECAST_NAME",
  SET_MODAL_URL: "SET_MODAL_URL",
  SET_MODAL_VISIBLE: "SET_MODAL_VISIBLE",
  SET_MODAL_TITLE: "SET_MODAL_TITLE",
  SET_MOBILE_MENU: "SET_MOBILE_MENU",
  SET_PLACE_RANKING: "SET_PLACE_RANKING",
  SET_COMPARISON_TYPE: "SET_COMPARISON_TYPE",
  SET_CHOROPLETH_BOUNDS: "SET_CHOROPLETH_BOUNDS",
  SET_COMPARISON_PARENT: "SET_COMPARISON_PARENT",
  SET_AVAILABLE_COMPARISONS: "SET_AVAILABLE_COMPARISONS",
  SET_DEFAULT_COMPARISON: "SET_DEFAULT_COMPARISON",

  SET_EAE: "SET_EAE",
  SET_EAE_VAR: "SET_EAE_VAR",
  SET_EAE_ISPCT: "SET_EAE_IS_PCT",
  SET_EAE_DERIVATIVE: "SET_EAE_DERIVATIVE",
  SET_EAE_SENSITIVITY: "SET_EAE_SENSITIVITY",
  SET_EAE_SCENARIO: "SET_EAE_SCENARIO",

  SET_ZILLOW_ISPCT: "SET_ZILLOW_ISPCT",
  SET_ZILLOW_MODEL: "SET_ZILLOW_MODEL",
  SET_ZILLOW_PATHWAY: "SET_ZILLOW_PATHWAY",
  SET_ZILLOW_PLACE_TYPE: "SET_ZILLOW_PLACE_TYPE",
  SET_ZILLOW_PLACE_TYPE_OPTIONS: "SET_ZILLOW_PLACE_TYPE_OPTIONS",
  SET_ZILLOW_PROB: "SET_ZILLOW_PROB",
  SET_ZILLOW_RANKING: "SET_ZILLOW_RANKING",
  SET_ZILLOW_VAR_TYPE: "SET_ZILLOW_VAR_TYPE",
  SET_ZILLOW_YEAR: "SET_ZILLOW_YEAR",
  SET_ZILLOW_YR_BUILT: "SET_ZILLOW_YR_BUILT", 
};

export function BatchActions(...actions) {
  return {
    type: ActionTypes.BATCH_ACTIONS,
    actions,
  };
}

/********* Global setting actions **************/
export function SetControlType(controlType) {
    return {
      type: ActionTypes.SET_CONTROL_TYPE,
      controlType,
    }
}

export function SetControlsEnabled(enabled) {
  return {
    type: ActionTypes.SET_CONTROLS_ENABLED,
    enabled,
  }
}

export function SetWaterLevel(waterLevel) {
  return {
    type: ActionTypes.SET_WATER_LEVEL,
    waterLevel,
  }
}

export function SetForecastCtrl(forecastCtrl) {
  return {
    type: ActionTypes.SET_FORECAST_CTRL,
    forecastCtrl,
  }
}


export function SetForecastMetadata(metadata) {
  return {
    type: ActionTypes.SET_FORECAST_METADATA,
    metadata,
  }
}

export function SetTimelineForecast(year, scenario, sensitivity) {
  return {
    type: ActionTypes.SET_TIMELINE_FORECAST,
    year,
    scenario,
    sensitivity,
  }
}

export function SetPreset(preset) {
  return {
    type: ActionTypes.SET_PRESET,
    preset,
  }
}

export function SetPresetLevels(presetLevels) {
  return {
    type: ActionTypes.SET_PRESET_LEVELS,
    presetLevels,
  }
}

export function SetSummary(order, data) {
  return {
    type: ActionTypes.SET_SUMMARY,
    order,
    data,
  }
}


/********* Navigation actions *****************/
export function SetPlaceName(placeName) {
  return {
    type: ActionTypes.SET_PLACE_NAME,
    placeName,
  }
}

export function SetPlace(placeType, placeID) {
  window.scrollTo(0, 0);
  return {
    type: ActionTypes.SET_PLACE,
    placeID,
    placeType,
  }
}

export function SetSSID(ssid) {
  return {
    type: ActionTypes.SET_SSID,
    ssid,
  }
}

export function SetPopulation(population) {
  return {
    type: ActionTypes.SET_POPULATION,
    population,
  }
}


export function SetPlaceContainer(placeContainer) {
  return {
    type: ActionTypes.SET_PLACE_CONTAINER,
    placeContainer,
  }
}

export function SetStations(stations) {
  return {
    type: ActionTypes.SET_STATIONS,
    stations,
  }
}

export function SetASLRStation(aslrStation) {
  return {
    type: ActionTypes.SET_ASLR_STATION,
    aslrStation,
  }
}

export function SetStationNum(stationNum) {
  return {
    type: ActionTypes.SET_STATION_NUM,
    stationNum,
  }
}

export function SetMapPosition(lat, lon, zoom=12) {
  return {
    type: ActionTypes.SET_MAP_POSITION,
    lon,
    lat,
    zoom,
  }
}

export function SetMapCaption(mapCaption) {
  return {
    type: ActionTypes.SET_MAP_CAPTION,
    mapCaption,
  }
}

export function SetMapLayer(mapLayer) {
  return {
    type: ActionTypes.SET_MAP_LAYER,
    mapLayer,
  }
}

export function SetQuery(query) {
  return {
    type: ActionTypes.SET_QUERY,
    query,
  }
}

export function SetMobileMenu(menuOpen) {
  return {
    type: ActionTypes.SET_MOBILE_MENU,
    menuOpen,
  }
}

export function SetModalVisible(visible) {
  return {
    type: ActionTypes.SET_MODAL_VISIBLE,
    visible,
  }
}

export function SetModalTitle(modalTitle) {
  return {
    type: ActionTypes.SET_MODAL_TITLE,
    modalTitle,
  }
}

export function SetEmbed(isEmbed) {
  return {
    type: ActionTypes.SET_EMBED,
    isEmbed,
  }
}

export function SetDownloadFormID(dlFormID) {
  return {
    type: ActionTypes.SET_DOWNLOAD_FORM_ID,
    dlFormID,
  }
}

/********** Component-specific actions *********/

export function SetImpactGroup(impactGroup) {
  return {
    type: ActionTypes.SET_IMPACT_GROUP,
    impactGroup,
  }
}

export function SetImpactSubgroupExclusions(subgroups) {
  return {
    type: ActionTypes.SET_IMPACT_SUBGROUP_EXCLUSIONS,
    impactSubgroupExclusions: subgroups,
  }
}

export function SetImpactSubgroup(impactSubgroup) {
  return {
    type: ActionTypes.SET_IMPACT_SUBGROUP,
    impactSubgroup,
  }
}

export function SetImpact(impact) {
  return {
    type: ActionTypes.SET_IMPACT,
    impact,
  }
}

export function SetImpactName(impactName) {
  return {
    type: ActionTypes.SET_IMPACT_NAME,
    impactName,
  }
}

export function SetImpactPct(impactPct) {
  return {
    type: ActionTypes.SET_IMPACT_PCT,
    impactPct,
  }
}

export function SetProtection(protectionModel) {
  return {
    type: ActionTypes.SET_PROTECTION,
    protection: protectionModel,
  }
}

export function SetForecastName(forecastName) {
  return {
    type: ActionTypes.SET_FORECAST_NAME,
    forecastName,
  }
}

export function SetForecastType(forecastType) {
  return {
    type: ActionTypes.SET_FORECAST_TYPE,
    forecastType,
  }
}

export function SetPlaceRanking(placeRanking) {
  return {
    type: ActionTypes.SET_PLACE_RANKING,
    placeRanking,
  }
}

export function SetComparisonType(comparisonType) {
  return {
    type: ActionTypes.SET_COMPARISON_TYPE,
    comparisonType,
  }
}

export function SetChoroplethBounds(choroplethBounds) {
  return {
    type: ActionTypes.SET_CHOROPLETH_BOUNDS,
    choroplethBounds,
  }
}

export function SetComparisonParent(comparisonParent) {
  return {
    type: ActionTypes.SET_COMPARISON_PARENT,
    comparisonParent,
  }
}

export function SetAvailableComparisons(availableComparisons) {
  return {
    type: ActionTypes.SET_AVAILABLE_COMPARISONS,
    availableComparisons,
  }
}

export function SetDefaultComparison(defaultComparison) {
  return {
    type: ActionTypes.SET_DEFAULT_COMPARISON,
    defaultComparison,
  }
}

export function SetEAE(eae) {
  return {
    type: ActionTypes.SET_EAE,
    eae,
  }
}

export function SetEAEVariable(variable) {
  return {
    type: ActionTypes.SET_EAE_VAR,
    variable,
  }
}

export function SetEAEIsPct(isPct) {
  return {
    type: ActionTypes.SET_EAE_ISPCT,
    isPct,
  }
}

export function SetEAEDerivative(derivative) {
  return {
    type: ActionTypes.SET_EAE_DERIVATIVE,
    derivative,
  }
}

export function SetEAESensitivity(percentile) {
  return {
    type: ActionTypes.SET_EAE_SENSITIVITY,
    percentile,
  }
}

export function SetEAEScenario(scenario) {
  return {
    type: ActionTypes.SET_EAE_SCENARIO,
    scenario,
  }
}

export function SetZillowIsPct(isPct) {
  return {
    type: ActionTypes.SET_ZILLOW_ISPCT,
    isPct,
  }
}

export function SetZillowModel(model) {
  return {
    type: ActionTypes.SET_ZILLOW_MODEL,
    model,
  }
}

export function SetZillowPathway(pathway) {
  return {
    type: ActionTypes.SET_ZILLOW_PATHWAY,
    pathway,
  }
}

export function SetZillowPlaceType(placeType) {
  return {
    type: ActionTypes.SET_ZILLOW_PLACE_TYPE,
    placeType,
  }
}

export function SetZillowPlaceTypeOptions(options) {
  return {
    type: ActionTypes.SET_ZILLOW_PLACE_TYPE_OPTIONS,
    options,
  }
}

export function SetZillowProb(prob) {
  return {
    type: ActionTypes.SET_ZILLOW_PROB,
    prob,
  }
}

export function SetZillowRanking(ranking) {
  return {
    type: ActionTypes.SET_ZILLOW_RANKING,
    ranking,
  }
}

export function SetZillowVarType(vartype) {
  return {
    type: ActionTypes.SET_ZILLOW_VAR_TYPE,
    vartype,
  }
}

export function SetZillowYear(year) {
  return {
    type: ActionTypes.SET_ZILLOW_YEAR,
    year,
  }
}

export function SetZillowYrBuilt(year) {
  return {
    type: ActionTypes.SET_ZILLOW_YR_BUILT,
    year,
  }
}
